import Container from "components/Container";
import { useBreadcrumb } from "features/breadcrumbs";
import ListaRelatorioUnidades from "./components/ListaRelatorioUnidades/index";

function RelatorioUnidades() {
  useBreadcrumb([
    { name: "Relatórios" },
    {
      name: "Unidades",
      url: "/relatorios/unidades",
    },
  ]);

  return (
    <Container>
      <ListaRelatorioUnidades />
    </Container>
  );
}

export default RelatorioUnidades;
